import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

const ErrorMessage = ({ 
  error, 
  onRetry = null, 
  showRetry = true,
  title = 'Si è verificato un errore'
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 text-red-600 rounded-full mb-4">
        <AlertTriangle className="w-8 h-8" />
      </div>
      
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      
      <p className="text-gray-600 mb-6 max-w-md">
        {error || 'Si è verificato un errore imprevisto. Riprova più tardi.'}
      </p>
      
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Riprova
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;